import { useState } from 'react';
import { Modal } from "react-bootstrap";

import ADSearchField from "./ADSearchField";

type MockUserModalProps = {
    showModal: boolean,
    closeInfoModal: () => void;
    userSelected: (email: string) => void;
}

const MockUserModal = ({ showModal, closeInfoModal, userSelected }: MockUserModalProps) => {
    const [selectedUserEmail, setSelectedUserEmail] = useState<string>('');
    return (<Modal
        className='modal-lg'
        show={showModal}
        onHide={() => closeInfoModal()}
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title className='user-data-modal-header'>
                <h3 className='ps-4 mt-2'>
                    Select Mock User
                </h3>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div
              className='row'
            >
                <div className='col-1'></div>
                <div className='col-7'>
                    <ADSearchField
                        dataName='MockUser'
                        title=''
                        hintText=''
                        disabled={false}
                        required={false}
                        optionValue='Email'
                        onchange={(email: string) => setSelectedUserEmail(email)}
                    />
                </div>
                <div className='col-1'></div>
                <div className='col-2 text-center pt-2'>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={() => {
                            userSelected(selectedUserEmail);
                            closeInfoModal();
                        }}
                        disabled={selectedUserEmail === ''}
                    >
                        Select User
                    </button>
                </div>
            </div>
        </Modal.Body>
    </Modal>);
};

export default MockUserModal;